import { Link } from "react-router-dom";
import { formatDate } from "../functions/formatDate";
import { formatURL } from "../functions/formatURL";


export default function LinkCard({intLink, title, category, text, url, date, image}){
        
    return <>
            <div className="link-card">
                <img className="post-img" src={image} />
                <div className="link-text">
                   <div className="link-top-line">
                    <p className="date">{formatDate(date)}</p>
                    <p className="link-cat">{category}</p>
                    
                    
                   </div>
                   <h2>{title}</h2>
                    
                   <p className="link-quote">{text}</p>
                   <Link to={url}>{formatURL(url)}</Link>
                </div>
            </div>
        </>
}